import { useTranslation } from 'react-i18next';
import { ErrorBanner } from '@platform/ui';
import { ModuleStringsProvider } from '@platform/modularity/ModuleStringsProvider';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { pageLabel } from '@platform/engine/menu/modulePages';
import { mainRecordTypeOf } from '@platform/engine/menu/moduleSections';
import type { IInsightViewPageProps } from './IInsightViewPageProps';
import { InsightViewBody } from './InsightViewBody';

/**
 * Аналітичне подання модуля (insight): тип запису сторінки (або головний) і підпис сторінки; сторінка з шапкою v4 і тілом — InsightViewBody
 * (власний компонент пакета з viewRegistry за ключем сторінки або заглушка).
 */
export function InsightViewPage({ ws, module, page }: IInsightViewPageProps) {
  const { t } = useTranslation();
  const strings = useModuleStrings(module.module.key);
  const rt = module.recordTypes.find((r) => r.key === page.recordType) ?? mainRecordTypeOf(module);
  const label = pageLabel(page, strings, (k) => t(`modulePages.${k}`));
  if (!rt) return <ErrorBanner error={{ message: 'No record types' }} />;
  return (
    <ModuleStringsProvider strings={strings}>
      <InsightViewBody ws={ws} module={module} rt={rt} page={page} label={label} />
    </ModuleStringsProvider>
  );
}
